module.exports = __webpack_public_path__ + "img/background-office-pc.028dec46.png";